export const DELIVERY_CRM_MAX_ATTEMPTS = 5
export const DELIVERY_CRM_UNKNOWN_ERROR_CODE = "crm_write_outcome_unknown"
